import React from "react";
import { InputProps, Form, Input, FormItemProps } from "antd";

import * as style from "./FormInputStyles.module.scss"

type Props = {
  inputProps: InputProps;
  formItemProps: FormItemProps;
};

const FormInput = ({ inputProps, formItemProps }: Props) => (
  <Form.Item {...formItemProps} className={style.input}>
    <Input {...inputProps} />
  </Form.Item>
);

export default FormInput;
